var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.5C4 7.63 7.13 4.5 11 4.5C14.87 4.5 18 7.63 18 11.5C18 13.2621 17.3511 14.8708 16.2789 16.1005L19.7802 19.611C20.0337 19.8652 20.0332 20.2767 19.779 20.5302C19.5248 20.7837 19.1133 20.7832 18.8598 20.529L15.3373 16.9973C14.1453 17.9386 12.639 18.5 11 18.5C7.13 18.5 4 15.37 4 11.5ZM16.7 11.5C16.7 8.36 14.14 5.8 11 5.8C7.86 5.8 5.3 8.36 5.3 11.5C5.3 14.64 7.86 17.2 11 17.2C14.14 17.2 16.7 14.64 16.7 11.5Z",
    fill: "#CED0D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.f0db6962818edb41638cc61ee4c14ba7.svg";
export { ForwardRef as ReactComponent };